/**
 * Adresse d'une image à la taille d'affichage voulue.
 *
 * Pour une image Cloudinary, on demande au CDN de la redimensionner (c_fill), de choisir le
 * format le plus léger pour le navigateur (f_auto : WebP/AVIF) et une qualité adaptée (q_auto) :
 * le téléphone ne télécharge jamais plus de pixels qu'il n'en affiche. Les autres adresses
 * (photos d'exemple, /images/…) sont renvoyées telles quelles.
 */
export function imageRedimensionnee(url: string, largeur: number, hauteur = largeur, centrerSurVisage = false): string {
  const marqueur = '/image/upload/'
  if (!url.startsWith('https://res.cloudinary.com/') || !url.includes(marqueur)) return url
  // g_face : si le format change (portrait carré affiché en 16:9), Cloudinary garde le visage dans le cadre.
  const gravite = centrerSurVisage ? ',g_face' : ''
  return url.replace(marqueur, `${marqueur}c_fill${gravite},w_${largeur},h_${hauteur},f_auto,q_auto/`)
}
